/**
 * GeoInit Component
 *
 * Initializes the geolocation state machine on app load.
 * - Restores position from sessionStorage
 * - Queries permission state
 * - Sets up visibility change listener for pause/resume
 */

import { useEffect } from "react"

import { isClientSide } from "@/lib/is-client-side"
import { geoVisibilityChanged } from "@/lib/storage/geolocation-actions"
import { initGeo } from "@/lib/storage/geolocation-thunks"
import { useAppDispatch } from "@/lib/storage/hooks"

export function GeoInit() {
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (!isClientSide()) return

    void dispatch(initGeo())

    // Set up visibility change listener for pause/resume
    const handleVisibility = () => {
      dispatch(
        geoVisibilityChanged(
          document.visibilityState === "visible" ? "visible" : "hidden"
        )
      )
    }

    document.addEventListener("visibilitychange", handleVisibility)

    return () => {
      document.removeEventListener("visibilitychange", handleVisibility)
    }
  }, [dispatch])

  return null
}
